import { ClassName } from 'types/props'

import { useUser } from '@/utilities/hooks/useUser'

import { Field } from '../field'

interface Props extends ClassName {
  id?: string
  label: string
}
export const ConfirmUsernameField = ({ className, id = 'confirmUsername', label }: Props) => {
  const { data: user, isLoading } = useUser()

  if (isLoading) return null

  return (
    <Field
      autoComplete="one-time-code"
      className={className}
      id={id}
      label={label}
      type="text"
      validators={{
        validate: value => {
          if (value === user.userName) return undefined
          return `Entered username does not match with your username: ${user.userName}`
        }
      }}
    />
  )
}
